import React from "react";
import { InfoIcon } from "../InfoIcon";
import type { Lexicon } from "../../lexicon";

type StatisticProps = {
  lexicon: Lexicon | string;
  border?: boolean;
  extra?: string
};

export const Statistic: React.FC<StatisticProps> = ({ lexicon, border = true, extra, children }) => {
  return (
    <div className={`flex flex-row justify-between py-3 ${border ? "border-divider" : ""}`}>
      <div className="flex flex-row items-center justify-start text-style-sub">
        {typeof lexicon === "string" ? (
          lexicon
        ) : (
          <>
            <div>
              {lexicon.term}
              {extra ?? (
                <span>{extra}</span>
              )}
            </div>
            {lexicon.term && <InfoIcon size="xs" tooltip={lexicon.description} link={lexicon.link} />}
          </>
        )}
      </div>
      <div className="flex justify-end items-cener text-style-item">{children}</div>
      {/* <Flex sx={{ borderBottom: 1, borderColor: "rgba(0, 0, 0, 0.1)" }}>
        <Flex sx={{ alignItems: "center", justifyContent: "flex-start", flex: 1.2, fontWeight: 200 }}>
          <Flex>{lexicon.term}</Flex>
          {lexicon.term && <InfoIcon size="xs" tooltip={lexicon.description} link={lexicon.link} />}
        </Flex>
        <Flex sx={{ justifyContent: "flex-end", flex: 1, alignItems: "center" }}>{children}</Flex>
      </Flex> */}
    </div>
  );
};
